export const isReactCompilerEnabled = () => {
  return window.sessionStorage.getItem('reactCompiler') === 'true';
};
